import {
  Button,
  Tile,
  TileContent,
  TileMedia,
  TileText,
  TileTitle,
} from '@design-system';
import { cn } from '@utils/cn';
import { useTranslation } from 'next-i18next';

import { AssetStoryblok } from '../../types/generated-storyblok';
import { Image } from '../Image';

export const ProductTilePlaceholder = ({
  artist,
  image,
  isLoading = false,
  isSubscribed = false,
  onSubscribe,
  title,
}: {
  artist?: string;
  image?: AssetStoryblok;
  isSubscribed?: boolean;
  isLoading?: boolean;
  onSubscribe: () => Promise<void>;
  title?: string;
}) => {
  const { t } = useTranslation('artists');

  return (
    <Tile
      className={cn('aspect-[3/4] overflow-hidden rounded-sm bg-neutral-2', {
        'theme-dark': image,
      })}
      direction="column"
    >
      {image ? (
        <TileMedia>
          <Image
            alt={image.alt || ''}
            eagerLoading
            focus={image.focus}
            size={{
              sm: { ratio: '3/4', span: 12 },
              md: { ratio: '3/4', span: 6 },
              lg: { ratio: '3/4', span: 4 },
            }}
            src={image.filename}
          />
          <span className="absolute inset-0 bg-neutral-6/40 backdrop-blur-md" />
        </TileMedia>
      ) : null}

      <TileContent
        className="absolute inset-0 z-10 p-4 text-center"
        direction="column"
      >
        <TileTitle className="text-center">
          {title || t('worksPlaceholder.title', { artist })}
        </TileTitle>
        <TileText className="mb-6 text-center">
          {t('worksPlaceholder.description')}
        </TileText>
        <Button
          disabled={isSubscribed}
          hideLabel={isSubscribed}
          icon={
            isSubscribed ? 'ic_notification_active' : 'ic_notification_outline'
          }
          label={t('worksPlaceholder.button')}
          loading={isLoading}
          onClick={() => void onSubscribe()}
          size="md"
          variant={isSubscribed ? 'positive' : 'primary'}
        />
      </TileContent>
    </Tile>
  );
};
